// extracted by mini-css-extract-plugin
export var externalLink = "_bf-0";
export var internalLinkLabel = "_bf-1";